// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSBarrageList/index.less
// module id = 1117
// module chunks = 42